import React from 'react';
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom';
import { parse } from 'url';
import { homepage } from '../package.json';

import Home from './Home.js';

import './App.css';

const basename = parse(homepage).pathname;

const App = () => (
  <BrowserRouter basename={basename}>
    <div>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route component={Home} />
      </Switch>
    </div>
  </BrowserRouter>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js